module.exports = __webpack_public_path__ + "static/newslettersServ-large-736a579e450a4daac7058fdf88a46d19.jpg";